import { SvgIcon, SvgIconProps } from '@mui/material';

interface AppIconProps extends SvgIconProps {
  Icon: React.FC<
    React.SVGProps<SVGSVGElement> & {
      title?: string;
    }
  >;
}
export const AppIcon: React.FC<AppIconProps> = ({ Icon, titleAccess, ...svgProps }) => {
  return (
    <SvgIcon
      titleAccess={titleAccess}
      component={({ viewBox: _viewBox, ...props }) => <Icon title={titleAccess} {...props} />}
      {...svgProps}
    />
  );
};
